import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PostService from "../api/PostService_old";
import { API_URL } from '../config/app-config';
import pdfIcon from "../images/pdf.png";
import docIcon from "../images/doc.png";
import folderIcon from "../images/folder.png";
import { MdDelete, MdOutlineEdit, MdArrowBack, MdUpload, MdInsertDriveFile } from "react-icons/md";

const COLORS = {
    primary: '#2563eb',
    secondary: '#4f46e5',
    danger: '#dc2626',
    success: '#16a34a',
    background: '#f8fafc',
    textPrimary: '#1e293b',
    textSecondary: '#64748b'
};

const styles = {
    container: {
        maxWidth: '720px',
        margin: '2rem auto',
        padding: '0 1.5rem',
        fontFamily: "'Inter', sans-serif",
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
        marginBottom: '2rem',
        padding: '1rem 0',
        borderBottom: '1px solid #e2e8f0',
        justifyContent: 'center',
    },
    copyLinkButton: {
        padding: '8px 16px',
        background: '#28a745',
        color: 'white',
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer',
        transition: 'background 0.3s ease',
        fontSize: '0.9rem',
        marginTop: '15px',
    },
    sectionSwitcher: {
        display: 'flex',
        justifyContent: 'center',
        gap: '20px',
        marginBottom: '40px',
    },
    switchButton: {
        padding: '12px 24px',
        background: '#f0f0f0',
        color: '#333',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        fontSize: '1rem',
        transition: 'all 0.3s ease',
    },
    switchButtonActive: {
        background: '#007bff',
        color: 'white',
    },
    switchButtonHover: {
        background: '#007bff',
        color: 'white',
    },
    title: {
        margin: 0,
        fontSize: '1.875rem',
        fontWeight: '600',
        color: COLORS.textPrimary,
        textAlign: 'center', // 👈 This works too
    },
    backButton: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        padding: '0.5rem 1rem',
        backgroundColor: 'transparent',
        color: 'rgb(255 255 255)',
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer',
        transition: 'all 0.2s',
        fontWeight: '500',
        ':hover': {
            backgroundColor: '#e0f2fe',
        },
    },
    tabContainer: {
        display: 'flex',
        gap: '0.5rem',
        marginBottom: '2rem',
        justifyContent: 'center',
    },
    tabButton: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        padding: '0.75rem 1.5rem',
        backgroundColor: '#f1f5f9',
        color: COLORS.textSecondary,
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'all 0.2s',
        fontWeight: '500',
        fontSize: '0.875rem',
    },
    activeTab: {
        backgroundColor: COLORS.primary,
        color: 'white',
    },
    uploadCard: {
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '2rem',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        marginBottom: '2rem',
    },
    formContainer: {
        display: 'grid',
        gap: '1.5rem',
        maxWidth: '600px',
        margin: '0 auto'
    },
    inputLabel: {
        display: 'block',
        marginBottom: '0.5rem',
        color: COLORS.textPrimary,
        fontWeight: '500'
    },
    inputField: {
        width: '100%',
        padding: '0.75rem',
        border: '1px solid #ced4da',
        borderRadius: '4px',
        fontSize: '1rem',
        transition: 'border-color 0.2s'
    },
    uploadArea: {
        border: `2px dashed #cbd5e1`,
        borderRadius: '8px',
        padding: '3rem 2rem',
        textAlign: 'center',
        transition: 'border-color 0.2s',
        cursor: 'pointer',
        margin: '1.5rem 0',
        ':hover': {
            borderColor: COLORS.primary,
            backgroundColor: '#f8fafc',
        },
    },
    uploadLabel: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1rem',
        cursor: 'pointer'
    },
    uploadIcon: {
        width: '50px',
        height: '50px',
        backgroundColor: '#e9ecef',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    uploadText: {
        margin: 0,
        color: COLORS.textPrimary,
        fontSize: '1rem'
    },
    uploadSubtext: {
        margin: 0,
        color: COLORS.textSecondary,
        fontSize: '0.9rem'
    },
    primaryButton: {
        width: '100%',
        padding: '1rem',
        backgroundColor: COLORS.primary,
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        fontSize: '1rem',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.2s',
        ':hover': {
            backgroundColor: '#1d4ed8',
        },
        ':disabled': {
            backgroundColor: '#94a3b8',
            cursor: 'not-allowed',
        },
    },
    gridContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
        gap: '1.5rem',
        marginBottom: '2rem',
    },
    card: {
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '1.5rem',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
        transition: 'transform 0.2s',
        cursor: 'pointer',
        position: 'relative',
        ':hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        },
    },
    cardActions: {
        position: 'absolute',
        top: '0.75rem',
        right: '0.75rem',
        display: 'flex',
        gap: '0.75rem',
    },
    editIcon: {
        color: COLORS.primary,
        cursor: 'pointer',
        transition: 'color 0.2s',
        ':hover': {
            color: '#1d4ed8',
        },
    },
    deleteIcon: {
        color: COLORS.danger,
        cursor: 'pointer',
        transition: 'color 0.2s',
        ':hover': {
            color: '#b91c1c',
        },
    },
    fileIcon: {
        width: '64px',
        height: '64px',
        margin: '0 auto 1rem',
        display: 'block',
    },
    fileName: {
        textAlign: 'center',
        fontWeight: '500',
        color: COLORS.textPrimary,
        fontSize: '0.95rem',
        wordBreak: 'break-word',
    },
    pagination: {
        display: 'flex',
        justifyContent: 'center',
        gap: '0.5rem',
        marginBottom: '2rem',
    },
    pageButton: {
        padding: '0.5rem 1rem',
        backgroundColor: '#e9ecef',
        color: 'rgb(255 255 255)',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        transition: 'all 0.2s'
    },
    activePage: {
        backgroundColor: COLORS.primary,
        color: 'white'
    },
    searchInput: {
        width: '100%',
        padding: '0.75rem',
        border: '1px solid #ced4da',
        borderRadius: '4px',
        fontSize: '1rem'
    }
};

const ConfirmDialog = ({ visible, message, onConfirm, onCancel }) => {
    if (!visible) return null;
    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
        }}>
            <div style={{
                backgroundColor: 'white',
                padding: '2rem',
                borderRadius: '8px',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                width: '400px',
                textAlign: 'center'
            }}>
                <p style={{ marginBottom: '1.5rem', fontSize: '1.1rem', color: COLORS.textPrimary }}>
                    {message}
                </p>
                <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
                    <button
                        onClick={onConfirm}
                        style={{
                            padding: '0.5rem 1.5rem',
                            backgroundColor: COLORS.danger,
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            transition: 'background-color 0.2s'
                        }}
                    >
                        Yes, Delete
                    </button>
                    <button
                        onClick={onCancel}
                        style={{
                            padding: '0.5rem 1.5rem',
                            backgroundColor: '#f1f5f9',
                            color: COLORS.textPrimary,
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            transition: 'background-color 0.2s'
                        }}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

const MyCommunityDocuments = ({ communityId }) => {
    // Upload States
    const [files, setFiles] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [documentName, setDocumentName] = useState('');
    const [tags, setTags] = useState('');
    const [selectedFolderId, setSelectedFolderId] = useState(null);
    const [newFolderName, setNewFolderName] = useState('');

    // Folder and Document View States
    const [uploadedDocuments, setUploadedDocuments] = useState([]); // Top-level folders with documents
    const [filteredDocuments, setFilteredDocuments] = useState([]); // Filtered folder list (by search)
    const [folders, setFolders] = useState([]); // For folder selection in upload

    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');

    // Pagination for Folder View
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);

    // State to track if user is "inside" a folder (viewing its documents)
    const [currentFolder, setCurrentFolder] = useState(null);

    // Section Toggle: 'upload' or 'view'
    const [activeSection, setActiveSection] = useState('upload');

    // Search for documents inside a folder
    const [docSearchQuery, setDocSearchQuery] = useState("");
    const [filteredFolderDocuments, setFilteredFolderDocuments] = useState([]);

    // States for inline editing
    const [editingFolder, setEditingFolder] = useState(null);
    const [editingDocument, setEditingDocument] = useState(null);
    const [editName, setEditName] = useState('');

    // State for our custom confirm dialog
    const [confirmData, setConfirmData] = useState({
        visible: false,
        message: '',
        onConfirm: null
    });

    useEffect(() => {
        fetchFolders();
    }, []);

    useEffect(() => {
        if (activeSection === 'view' && !currentFolder) {
            fetchDocuments(0);
        }
    }, [activeSection, currentFolder]);

    useEffect(() => {
        if (!searchQuery) {
            setFilteredDocuments(uploadedDocuments);
            return;
        }
        const filtered = uploadedDocuments.filter((folder) =>
            folder.folderName.toLowerCase().includes(searchQuery.toLowerCase())
        );
        setFilteredDocuments(filtered);
    }, [searchQuery, uploadedDocuments]);

    useEffect(() => {
        if (currentFolder && currentFolder.documents) {
            if (!docSearchQuery) {
                setFilteredFolderDocuments(currentFolder.documents);
            } else {
                setFilteredFolderDocuments(
                    currentFolder.documents.filter((doc) =>
                        doc.name.toLowerCase().includes(docSearchQuery.toLowerCase()) ||
                        (doc.tags && doc.tags.toLowerCase().includes(docSearchQuery.toLowerCase()))
                    )
                );
            }
        }
    }, [docSearchQuery, currentFolder]);

    const fetchFolders = async () => {
        try {
            const response = await PostService.getFolders();
            if (response?.data?.status === 1) {
                setFolders(response.data.data);
            }
        } catch (error) {
            toast.error("Error fetching folders!", { position: "top-right" });
        }
    };

    const fetchDocuments = async (page) => {
        setLoading(true);
        try {
            const response = await PostService.getDocumentsByUser(page, 8, communityId); // Pass communityId here
            if (response?.data?.status === 1 && Array.isArray(response.data.data.folders)) {
                setUploadedDocuments(response.data.data.folders);
                setFilteredDocuments(response.data.data.folders);
                setCurrentPage(response.data.data.folderPagination.currentPage);
                setTotalPages(response.data.data.folderPagination.totalPages);
            } else {
                toast.warn("No documents found!", { position: "top-right" });
                setUploadedDocuments([]);
                setFilteredDocuments([]);
            }
        } catch (error) {
            toast.error("Error fetching documents!", { position: "top-right" });
            setUploadedDocuments([]);
            setFilteredDocuments([]);
        } finally {
            setLoading(false);
        }
    };

    const fetchFolderDocuments = async (folderId, page) => {
        setLoading(true);
        try {
            const response = await PostService.getFolderDocuments(folderId, page, 8);
            if (response?.data?.status === 1) {
                setCurrentFolder(response.data.data);
            } else {
                toast.warn("No documents found in folder!", { position: "top-right" });
            }
        } catch (error) {
            toast.error("Error fetching folder documents!", { position: "top-right" });
        } finally {
            setLoading(false);
        }
    };

    const handleFileChange = (e) => {
        const selectedFiles = [...e.target.files];
        const oversizedFiles = selectedFiles.filter((file) => file.size > 5 * 1024 * 1024);
        if (oversizedFiles.length > 0) {
            toast.warn("Files larger than 5MB are not allowed!", { position: "top-right" });
            return;
        }
        setFiles(selectedFiles);
    };

    const handleUpload = async () => {
        if (files.length === 0 || !documentName.trim()) {
            toast.warn(files.length === 0 ? "Please select files to upload!" : "Please enter a document name!", { position: "top-right" });
            return;
        }
        if (!selectedFolderId && !newFolderName.trim()) {
            toast.warn("Please select a folder or create a new one!", { position: "top-right" });
            return;
        }

        setUploading(true);
        const formData = new FormData();
        files.forEach((file) => formData.append('mediaTypeFile', file));
        formData.append('name', documentName);
        formData.append('folderId', selectedFolderId || '');
        formData.append('folderName', newFolderName);
        formData.append('tag', tags);
        formData.append('subjectId', communityId);

        try {
            const response = await PostService.uploadDocument(formData);
            if (response?.data?.status === 1 && response.data.data) {
                toast.success("Upload successful!", { position: "top-right" });
                setFiles([]);
                setDocumentName('');
                setSelectedFolderId(null);
                setNewFolderName('');
                setTags('');
                fetchDocuments(currentPage);
                setActiveSection('view');
            } else {
                toast.error("Upload failed!", { position: "top-right" });
            }
        } catch (error) {
            toast.error("Upload error!", { position: "top-right" });
        } finally {
            setUploading(false);
        }
    };

    const handleCopyLink = (folderId, documentId) => {
        const link = `${API_URL}api/viewDocument/${folderId}/${documentId}`;
        navigator.clipboard.writeText(link).then(() => {
            toast.success("Link copied to clipboard!", { position: "top-right" });
        });
    };

    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
    };

    const handleDocSearch = (e) => {
        setDocSearchQuery(e.target.value);
    };

    const handleFolderDoubleClick = (folder) => {
        setCurrentFolder(folder);
        setDocSearchQuery("");
        setFilteredFolderDocuments(folder.documents || []);
    };

    const handleFolderDocPageChange = (newPage) => {
        if (currentFolder) {
            fetchFolderDocuments(currentFolder.folderId, newPage);
        }
    };

    // ----- Editing Handlers for Folders -----
    const handleFolderEdit = (folder, e) => {
        e.stopPropagation();
        setEditingFolder(folder);
        setEditName(folder.folderName);
    };

    const handleFolderUpdate = async (folder) => {
        try {
            const response = await PostService.updateDetails({
                type: "folder",
                folderId: folder.folderId,
                folderName: editName
            });
            if (response?.data?.status === 1) {
                toast.success("Folder updated successfully");
                fetchDocuments(currentPage);
                setEditingFolder(null);
            } else {
                toast.error("Folder update failed");
            }
        } catch (error) {
            toast.error("Error updating folder");
        }
    };

    const performFolderDelete = async (folder) => {
        try {
            const response = await PostService.deleteDetails({
                type: "folder",
                folderId: folder.folderId
            });
            if (response?.data?.status === 1) {
                toast.success("Folder deleted successfully");
                fetchDocuments(currentPage);
            } else {
                toast.error("Folder deletion failed");
            }
        } catch (error) {
            toast.error("Error deleting folder");
        } finally {
            setConfirmData({ visible: false, message: '', onConfirm: null });
        }
    };

    const handleFolderDelete = (folder, e) => {
        e.stopPropagation();
        setConfirmData({
            visible: true,
            message: `Are you sure you want to delete this folder?`,
            onConfirm: () => performFolderDelete(folder)
        });
    };

    // ----- Editing Handlers for Documents -----
    const handleDocumentEdit = (document, e) => {
        e.stopPropagation();
        setEditingDocument(document);
        setEditName(document.name);
    };

    const handleDocumentUpdate = async (document) => {
        try {
            const response = await PostService.updateDetails({
                type: "document",
                fileId: document.fileId,
                fileName: editName
            });
            if (response?.data?.status === 1) {
                toast.success("Document updated successfully");
                if (currentFolder) {
                    fetchFolderDocuments(currentFolder.folderId, currentFolder.docPagination.currentPage);
                }
                setEditingDocument(null);
            } else {
                toast.error("Document update failed");
            }
        } catch (error) {
            toast.error("Error updating document");
        }
    };

    const performDocumentDelete = async (document) => {
        try {
            const response = await PostService.deleteDetails({
                type: "document",
                fileId: document.fileId
            });
            if (response?.data?.status === 1) {
                toast.success("Document deleted successfully");
                if (currentFolder) {
                    fetchFolderDocuments(currentFolder.folderId, currentFolder.docPagination.currentPage);
                }
            } else {
                toast.error("Document deletion failed");
            }
        } catch (error) {
            toast.error("Error deleting document");
        } finally {
            setConfirmData({ visible: false, message: '', onConfirm: null });
        }
    };

    const handleDocumentDelete = (document, e) => {
        e.stopPropagation();
        setConfirmData({
            visible: true,
            message: `Are you sure you want to delete this document?`,
            onConfirm: () => performDocumentDelete(document)
        });
    };

    return (
        <div style={styles.container}>
            <div style={styles.uploadCard}>
                <div style={styles.header}>
                    {currentFolder && (
                        <button
                            onClick={() => setCurrentFolder(null)}
                            style={styles.backButton}
                        >
                            <MdArrowBack size={20} />
                            <span>Back</span>
                        </button>
                    )}
                    <div style={{ textAlign: 'center' }}>
                        <h1 style={styles.title}>
                            {activeSection === 'upload'
                                ? 'Community Documents'
                                : currentFolder ? currentFolder.folderName : 'Community Documents'}
                        </h1>
                    </div>
                </div>

                {!currentFolder && (
                    <div style={styles.sectionSwitcher}>
                        <button
                            style={{
                                ...styles.switchButton,
                                ...(activeSection === 'upload' ? styles.switchButtonActive : {})
                            }}
                            onClick={() => setActiveSection('upload')}
                        >
                            Upload Documents
                        </button>
                        <button
                            style={{
                                ...styles.switchButton,
                                ...(activeSection === 'view' ? styles.switchButtonActive : {})
                            }}
                            onClick={() => setActiveSection('view')}
                        >
                            View Documents
                        </button>
                    </div>
                )}
            </div>
            {activeSection === 'upload' && (
                <div style={styles.uploadCard}>
                    <div style={styles.formContainer}>
                        <div>
                            <label style={styles.inputLabel}>Document Name</label>
                            <input
                                value={documentName}
                                onChange={(e) => setDocumentName(e.target.value)}
                                style={styles.inputField}
                                placeholder="Enter document name"
                            />
                        </div>

                        <div>
                            <label style={styles.inputLabel}>Select Folder</label>
                            <select
                                value={selectedFolderId || ''}
                                onChange={(e) => {
                                    setSelectedFolderId(e.target.value);
                                    setNewFolderName('');
                                }}
                                style={styles.inputField}
                            >
                                <option value="">Select a folder</option>
                                {folders.map((folder) => (
                                    <option key={folder.id} value={folder.id}>{folder.folderName}</option>
                                ))}
                            </select>
                        </div>

                        {!selectedFolderId && (
                            <div>
                                <label style={styles.inputLabel}>Create New Folder</label>
                                <input
                                    value={newFolderName}
                                    onChange={(e) => setNewFolderName(e.target.value)}
                                    style={styles.inputField}
                                    placeholder="Enter new folder name"
                                />
                            </div>
                        )}

                        <div>
                            <label style={styles.inputLabel}>Tags</label>
                            <input
                                value={tags}
                                onChange={(e) => setTags(e.target.value)}
                                style={styles.inputField}
                                placeholder="Enter tags (comma separated)"
                            />
                        </div>

                        <div style={styles.uploadArea}>
                            <input
                                type="file"
                                id="file-upload"
                                multiple
                                onChange={handleFileChange}
                                style={{ display: 'none' }}
                            />
                            <label htmlFor="file-upload" style={styles.uploadLabel}>
                                <div style={styles.uploadIcon}>
                                    <MdUpload size={40} color={COLORS.primary} />
                                </div>
                                <p style={styles.uploadText}>
                                    {files.length > 0
                                        ? `${files.length} file${files.length > 1 ? 's' : ''} selected`
                                        : 'Drag & drop or click to browse'}
                                </p>
                                <p style={styles.uploadSubtext}>
                                    Max file size: 5MB • Supported formats: PDF, DOC, DOCX, JPG, PNG
                                </p>
                            </label>
                        </div>

                        <button
                            onClick={handleUpload}
                            disabled={uploading || files.length === 0}
                            style={styles.primaryButton}
                        >
                            {uploading ? 'Uploading...' : 'Upload Documents'}
                        </button>
                    </div>
                </div>
            )}

            {activeSection === 'view' && !currentFolder && (
                <>
                    <div style={styles.gridContainer}>
                        {filteredDocuments.map((folder) => (
                            <div
                                key={folder.folderId}
                                style={styles.card}
                                onDoubleClick={() => handleFolderDoubleClick(folder)}
                            >
                                <div className="card-icons">
                                    <button className="icon-button edit-button" onClick={(e) => handleFolderEdit(folder, e)}><MdOutlineEdit /></button>
                                    <button className="icon-button delete-button" onClick={(e) => handleFolderDelete(folder, e)}><MdDelete /></button>
                                </div>
                                <img
                                    src={folderIcon}
                                    alt="Folder"
                                    style={styles.fileIcon}
                                />
                                <div style={styles.fileName}>
                                    {folder.folderName}
                                </div>
                            </div>
                        ))}
                    </div>

                    <div style={styles.pagination}>
                        <button
                            disabled={currentPage === 0}
                            onClick={() => fetchDocuments(currentPage - 1)}
                            style={{
                                ...styles.pageButton,
                                ...(currentPage !== 0 && { backgroundColor: COLORS.primary, color: 'white' })
                            }}
                        >
                            Previous
                        </button>
                        {Array.from({ length: totalPages }, (_, i) => (
                            <button
                                key={i}
                                onClick={() => fetchDocuments(i)}
                                style={{
                                    ...styles.pageButton,
                                    ...(i === currentPage && styles.activePage)
                                }}
                            >
                                {i + 1}
                            </button>
                        ))}
                        <button
                            disabled={currentPage + 1 >= totalPages}
                            onClick={() => fetchDocuments(currentPage + 1)}
                            style={{
                                ...styles.pageButton,
                                ...(currentPage + 1 < totalPages && { backgroundColor: COLORS.primary, color: 'white' })
                            }}
                        >
                            Next
                        </button>
                    </div>
                </>
            )}

            {activeSection === 'view' && currentFolder && (
                <div style={styles.uploadCard}>
                    <div style={{ marginBottom: '2rem' }}>
                        <input
                            type="text"
                            placeholder="Search documents..."
                            value={docSearchQuery}
                            onChange={handleDocSearch}
                            style={styles.searchInput}
                        />
                    </div>

                    <div style={styles.gridContainer}>
                        {filteredFolderDocuments.map((document) => (
                            <div key={document.id} style={styles.card}>
                                <div style={styles.cardActions}>
                                    <MdOutlineEdit
                                        onClick={(e) => handleDocumentEdit(document, e)}
                                        style={styles.editIcon}
                                    />
                                    <MdDelete
                                        onClick={(e) => handleDocumentDelete(document, e)}
                                        style={styles.deleteIcon}
                                    />
                                </div>
                                <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
                                    <img
                                        src={document.fileName?.endsWith('.pdf') ? pdfIcon : docIcon}
                                        alt="Document type"
                                        style={styles.fileIcon}
                                    />
                                </div>
                                <div style={styles.fileName}>{document.name}
                                    <button
                                        onClick={() => handleCopyLink(currentFolder.folderId, document.id)}
                                        style={styles.copyLinkButton}
                                    >
                                        Copy Link
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div style={styles.pagination}>
                        <button
                            disabled={currentFolder.docPagination.currentPage === 0}
                            onClick={() => handleFolderDocPageChange(currentFolder.docPagination.currentPage - 1)}
                            style={{
                                ...styles.pageButton,
                                ...(currentFolder.docPagination.currentPage !== 0 && {
                                    backgroundColor: COLORS.primary,
                                    color: 'white'
                                })
                            }}
                        >
                            Previous
                        </button>
                        {Array.from({ length: currentFolder.docPagination.totalPages }, (_, i) => (
                            <button
                                key={i}
                                onClick={() => handleFolderDocPageChange(i)}
                                style={{
                                    ...styles.pageButton,
                                    ...(i === currentFolder.docPagination.currentPage && styles.activePage)
                                }}
                            >
                                {i + 1}
                            </button>
                        ))}
                        <button
                            disabled={currentFolder.docPagination.currentPage + 1 >= currentFolder.docPagination.totalPages}
                            onClick={() => handleFolderDocPageChange(currentFolder.docPagination.currentPage + 1)}
                            style={{
                                ...styles.pageButton,
                                ...(currentFolder.docPagination.currentPage + 1 < currentFolder.docPagination.totalPages && {
                                    backgroundColor: COLORS.primary,
                                    color: 'white'
                                })
                            }}
                        >
                            Next
                        </button>
                    </div>
                </div>
            )}

            <ConfirmDialog
                visible={confirmData.visible}
                message={confirmData.message}
                onConfirm={confirmData.onConfirm}
                onCancel={() => setConfirmData({ visible: false, message: '', onConfirm: null })}
            />
        </div>
    );
};

export default MyCommunityDocuments;
